import React, {useEffect, useState} from "react";

const FormCampoTXT = ({
                        label,
                        valor,
                        setValor,
                        com,
                        isRequerido = false,
                        isNumericNatural = false,
                        isFlex = false,
                        isEmail=false,
                        wLabel = null,
                        wInput = null,
                        isHide
                      }) => {
  
  const [isValid, setIsValid] = useState(true);
  
  useEffect(() => {
    if (isRequerido) {
      setIsValid(!!valor);
    } else {
      setIsValid(true);
    }
    
  }, [isRequerido, valor])
  
  
  if (isHide) {
    return null;
  }
  const iconRequerido = isRequerido ? "* " : " "
  
  const onChange = (event) => {
    const v = event.target.value;
    setValor(v);
  }
  
  
  const cssLabel = isValid
    ? "label has-text-right label170"
    : "label has-text-right has-text-danger label170";
  
  const elemCom = com ? <small>{com}</small> : null;
  
  const type = isNumericNatural ? "number" :  (isEmail?"email":"text");
  
  let style={}
  if(wInput){
    style={width:`${wInput}px`}
  }
  
  const input = isNumericNatural
    ? (<input className="input"
              type={type}
              value={valor}
              pattern="[0-9]."
              onChange={onChange}
    />)
    : (<input className="input"
              type={type}
              value={valor}
              onChange={onChange}/>)
  
  
  if (isFlex) {
    
    const labelControl = wLabel
      ? (<div style={{textTransform: "capitalize", width:`${wLabel}px`, textAlign:"right"}}>
        {label} {iconRequerido}
      </div>)
      : (<div style={{textTransform: "capitalize"}}>
        {label} {iconRequerido}
      </div>);
    
    return (<div className="is-flex m5B">
      <div className="m10R">
        {labelControl}
      </div>
      <div className="control  flexGrow1">
        {input}
        {elemCom}
      </div>
    
    </div>);
    
  }
  return (
    <div className="field is-horizontal">
      <div className="field-label is-normal ">
        <label className={cssLabel}>
          {label} {iconRequerido}
        </label>
      </div>
      <div className="field-body">
        <div className="field">
          <p className="control">
            {input}
            {elemCom}
          </p>
        </div>
      </div>
    
    </div>
  
  
  );
};

export default FormCampoTXT